{
  "page": {
    "title": "ヘルプ",
    "intro": "おもな作業の短いガイドと、税金・法律のことばの意味です。",
    "guides": "30秒ガイド",
    "topics": "このことばの意味は？",
    "back": "ヘルプの一覧",
    "not_found": "このヘルプページはありません。",
    "english_only": "このページはまだ日本語がありません。英語で表示しています。",
    "tour_again": "ホームの案内をもう一度見る",
    "checklist_again": "ホームに「お店の準備」をまた表示する",
    "checklist_shown": "ホームにリストを戻しました。",
    "tour_reset": "次にホームを開いたときに案内が始まります。",
    "tools": "ヘルプの機能",
    "open_guide": "このページのガイド"
  },
  "checklist": {
    "title": "お店の準備",
    "intro": "最初に一度だけ設定します。終わると自動で緑になります。",
    "progress": "{{total}}件中 {{done}}件 完了",
    "hide": "このリストを隠す",
    "hidden": "リストを隠しました。ヘルプ →「お店の準備をまた表示」で戻せます。",
    "all_done": "お店の準備ができました。このリストは隠せます。",
    "go": "設定する",
    "open": "開く",
    "status": {
      "done": "完了",
      "todo": "未設定",
      "unknown": "確認できません",
      "no_access": "オーナーに依頼"
    },
    "items": {
      "store": {
        "title": "お店の情報",
        "body": "名前・住所・電話・メール。法律のページとメールに使います。ロゴはウェブのデザインで設定します。"
      },
      "tokushoho": {
        "title": "特商法表記",
        "body": "14項目。すべて埋まると完了です（いま {{percent}}%）。"
      },
      "tax": {
        "title": "税金：登録番号と海外への販売",
        "body": "T番号と、海外向け価格の見せ方。"
      },
      "payments": {
        "title": "支払い方法：振込口座とカード端末",
        "body": "お客様が振り込む口座と、手数料％つきのカード端末。"
      },
      "shipping": {
        "title": "配送：国内と海外",
        "body": "国内の配送方法と、海外への配送方法を1つ以上。"
      },
      "register": {
        "title": "レジ",
        "body": "レジ1台と、そのタブレットの接続。"
      },
      "first_card": {
        "title": "最初のカード",
        "body": "約2分でカードを登録します。"
      },
      "staff": {
        "title": "スタッフ",
        "body": "一緒に働く人を、それぞれのログインで追加します。"
      },
      "two_step": {
        "title": "あなたの2段階認証",
        "body": "ログインのたびにスマホのアプリのコードを入れて、お店を守ります。"
      }
    }
  },
  "coach": {
    "label": "ホームの案内",
    "step": "{{total}}つ中 {{n}}つ目",
    "next": "次へ",
    "done": "わかった",
    "skip": "案内をとばす",
    "list_title": "知っておきたい3つのこと",
    "big_actions": {
      "title": "大きなボタン",
      "body": "毎日の作業：カード登録、発送する注文、委託の受付、レジを開く。"
    },
    "search": {
      "title": "なんでも探す",
      "body": "カード名・注文番号を入力するか、コードをスキャン。キーボードなら Ctrl + K。"
    },
    "inbox": {
      "title": "やることリスト",
      "body": "ベルに、あなたの対応が必要なこと（入金確認・発送・問題）が出ます。赤＝急ぎ。"
    }
  },
  "feedback": {
    "button": "問題・アイデアを送る",
    "title": "問題やアイデアを教えてください",
    "kind": "どちらですか？",
    "kind_problem": "うまく動かない",
    "kind_idea": "もっと使いやすくするアイデア",
    "message": "何が起きましたか？ 何があると助かりますか？",
    "message_hint": "お客様の名前・住所・カード番号は書かないでください。",
    "message_required": "まず少し書いてください。",
    "attached": "いっしょに送るもの：このページ、時刻、最後の問題の番号（{{requestId}}）。",
    "attached_none": "いっしょに送るもの：このページと時刻。",
    "send": "送る",
    "sent": "ありがとうございます。送りました。",
    "email_instead": "メールで送る",
    "no_channel": "ここからはまだ送れません。メールを使ってください：",
    "failed": "送れませんでした。もう一度ためすか、メールを使ってください。"
  },
  "usability": {
    "title": "ユーザビリティテスト（観察者用）",
    "panel": "ユーザビリティテストの操作盤（観察者のみ）",
    "start": "課題 {{n}} を開始",
    "done": "完了",
    "gave_up": "断念",
    "download_other": "結果をダウンロード（{{count}} 件）"
  }
}
